import axios from 'axios';

import { API_BASE_URL } from '../config';

const GRAPHQL_URL = `${API_BASE_URL}/graphql`;

export const gql = (query: string, variables: any = {}, token?: string) => {
	const headers: any = {
		'Content-Type': 'application/json',
	};

	if (token) {
		headers['Authorization'] = `Bearer ${token}`;
	}

	return axios.post(GRAPHQL_URL, {
		query,
		variables,
	}, { headers, withCredentials: true });
};
